import { PropsWithChildren, RefObject } from 'react';
import { createPortal } from 'react-dom';
import { MdTripOrigin } from 'react-icons/md';
import { Divider, Listbox, ListboxItem, Popover, PopoverContent, Selection } from '@ds';
import { getSShiftDropdownOptionIconColor } from '@lp/features/Scheduler/SchedulerSurgeons/utils';
import { S_SHIFT_TYPE_DROPDOWN_LIST } from '@lp/features/Scheduler/SchedulerSurgeons/constants';
import { SShift, SShiftType } from '@/api/apis/resources/schedule';

type SShiftCellDropdownProps = PropsWithChildren<{
  title?: string;
  isPlacementBottom?: boolean;
  shiftData?: SShift;
  onShiftChange: (shiftType?: SShiftType) => void;
  triggerRef: RefObject<HTMLButtonElement | null>;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  isExternalRegion?: boolean;
  canReset?: boolean;
}>;

export const SShiftCellDropdown = ({
  title = 'Change Status',
  isPlacementBottom,
  isOpen,
  onOpenChange,
  triggerRef,
  shiftData,
  onShiftChange,
  isExternalRegion,
  canReset,
}: SShiftCellDropdownProps) => {
  const selectedShiftOption = isExternalRegion ? undefined : shiftData?.shiftType;

  const onSelectionChange = (keys: Selection) => {
    if (keys !== 'all') {
      const selected = Array.from(keys)[0] as SShiftType | undefined;
      onShiftChange(selected);
      onOpenChange(false);
    }
  };

  return createPortal(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    <Popover
      placement={isPlacementBottom ? 'bottom-start' : 'right-start'}
      // @ts-expect-error HeroUI Popover triggerRef expects RefObject<HTMLElement>, React 19 provides RefObject<HTMLButtonElement | null>
      triggerRef={triggerRef}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      shouldCloseOnInteractOutside={(el) => el !== triggerRef.current && !triggerRef.current?.contains(el)}
    >
      <PopoverContent>
        <Listbox
          selectionMode="single"
          disallowEmptySelection={!canReset}
          selectedKeys={selectedShiftOption ? [selectedShiftOption] : undefined}
          onSelectionChange={onSelectionChange}
          aria-label="Change Shift Status"
          topContent={
            <>
              <span className="pl-2 text-s-m text-base-20">{title}</span>
              <Divider orientation="horizontal" />
            </>
          }
        >
          {S_SHIFT_TYPE_DROPDOWN_LIST.map((optionItem) => {
            const color = getSShiftDropdownOptionIconColor(optionItem.value);

            return (
              <ListboxItem
                key={optionItem.value}
                textValue={optionItem.name}
                startContent={<MdTripOrigin size={16} className={color} />}
              >
                {optionItem.name}
              </ListboxItem>
            );
          })}
        </Listbox>
      </PopoverContent>
    </Popover>,
    document.body,
  );
};
